import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { MailIcon, MessageSquareIcon } from 'lucide-react';
export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, this would send the form data to a server
    window.location.href = `mailto:rapeezshrestha385@gmail.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\n${formData.message}`)}`;
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="bg-white" data-id="element-314">
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-brand-light" data-id="element-315">
        <div className="container-custom" data-id="element-316">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center max-w-3xl mx-auto" data-id="element-317">
            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6" data-id="element-318">
              Get in touch
            </h1>
            <p className="text-xl text-gray-600" data-id="element-319">
              Have a question or want to learn more? We'd love to hear from you.
            </p>
          </motion.div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-320">
        <div className="container-custom max-w-5xl" data-id="element-321">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-322">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-323">
              <h2 className="text-2xl font-bold text-brand-blue mb-6" data-id="element-324">
                Contact information
              </h2>
              <div className="space-y-6" data-id="element-325">
                <div className="flex items-start" data-id="element-326">
                  <MailIcon className="h-6 w-6 text-brand-teal mr-4 flex-shrink-0 mt-1" data-id="element-327" />
                  <div data-id="element-328">
                    <h3 className="font-semibold text-brand-blue mb-1" data-id="element-329">
                      Email
                    </h3>
                    <a href="mailto:rapeezshrestha385@gmail.com" className="text-gray-600 hover:text-brand-teal transition-colors duration-200" data-id="element-330">
                      rapeezshrestha385@gmail.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-331">
                  <MessageSquareIcon className="h-6 w-6 text-brand-teal mr-4 flex-shrink-0 mt-1" data-id="element-332" />
                  <div data-id="element-333">
                    <h3 className="font-semibold text-brand-blue mb-1" data-id="element-334">
                      Support
                    </h3>
                    <p className="text-gray-600" data-id="element-335">
                      We typically respond within 24 hours on weekdays.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-8 bg-brand-light rounded-lg p-6" data-id="element-336">
                <h3 className="font-semibold text-brand-blue mb-3" data-id="element-337">
                  Prefer to book a demo?
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-338">
                  Schedule a personalised demo to see Daily Serve in action.
                </p>
                <a href="/demo" className="btn-primary inline-block" data-id="element-339">
                  Book a demo
                </a>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-340">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-341">
                <div data-id="element-342">
                  <label htmlFor="name" className="block text-sm font-medium text-brand-blue mb-2" data-id="element-343">
                    Name
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-teal focus:border-transparent" data-id="element-344" />
                </div>
                <div data-id="element-345">
                  <label htmlFor="email" className="block text-sm font-medium text-brand-blue mb-2" data-id="element-346">
                    Email
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-teal focus:border-transparent" data-id="element-347" />
                </div>
                <div data-id="element-348">
                  <label htmlFor="subject" className="block text-sm font-medium text-brand-blue mb-2" data-id="element-349">
                    Subject
                  </label>
                  <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-teal focus:border-transparent" data-id="element-350" />
                </div>
                <div data-id="element-351">
                  <label htmlFor="message" className="block text-sm font-medium text-brand-blue mb-2" data-id="element-352">
                    Message
                  </label>
                  <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-teal focus:border-transparent" data-id="element-353" />
                </div>
                <button type="submit" className="btn-primary w-full" data-id="element-354">
                  Send message
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
};